import {
    CREATE_ADMIN_CAMPAIGNS, LOADING_CREATE_ADMIN_CAMPAING, LOADING_GET_ALL_ADMIN_CAMPAING, GET_ALL_ADMIN_CAMPAING,
    DELETE_ADMIN_CAMPAING, LOADING_DELETE_ADMIN_CAMPAING, UPDATE_ADMIN_CAMPAING, LOADING_UPDATE_ADMIN_CAMPAING,GET_ADMIN_CAMPAING_BY_ID,
    LOADING_GET_ADMIN_CAMPAING_BY_ID
} from '../actions/types'

const initialState = {
    loadingCreate: false,
    loadingGetAll: false,
    listCampaigns: [],
    loadingDelete: false,
    loadingUpdate: false,
    loadingGetById: false,
    getCampaignById:[],

}
export default function (state = initialState, action) {
    switch (action.type) {

        case LOADING_CREATE_ADMIN_CAMPAING:
            return { ...state, loadingCreate: true }
        case CREATE_ADMIN_CAMPAIGNS:
            return { ...state, CREATE_ADMIN_CAMPAIGNS }
        case LOADING_GET_ALL_ADMIN_CAMPAING:
            return { ...state, loadingGetAll: true }
        case GET_ALL_ADMIN_CAMPAING:
            return { ...state, listCampaigns: action.payload }
        case LOADING_DELETE_ADMIN_CAMPAING:
            return { ...state, loadingDelete: true }
        case DELETE_ADMIN_CAMPAING:
            var newCampaignsList = state.listCampaigns
            newCampaignsList.splice(action.payload,1)
            return { ...state, loadingDelete: false, listCampaigns: newCampaignsList }
        case LOADING_UPDATE_ADMIN_CAMPAING:
            return { ...state, loadingUpdate: true }
        case UPDATE_ADMIN_CAMPAING:
            return { ...state, loadingUpdate: false,adminCampaignsList:action.payload }
        case LOADING_GET_ADMIN_CAMPAING_BY_ID:
            return { ...state, loadingGetById:true}    
        case GET_ADMIN_CAMPAING_BY_ID:
            return { ...state, loadingGetById: false,getCampaignById: action.payload.data }
        default:
            return state

    }
}